var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_vm._v("\n      역할\n    ")]),_vm._l((_vm.items),function(item){return _c('instructor-role-inline-form',{key:item.id,attrs:{"data":item,"is-active":item.id === _vm.activeRoleId}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }